export default "__VITE_ASSET__DY$uBjTM__"